<template>
  <div class="flex flex-col space-y-5">
    <div class="text-center">
      NFPA 285 Compliance Test
    </div>
    <div class="">
      <div class="flex flex-wrap -mx-2">

        <IconButton :on-click="() => $emit('update:modelValue', true)" :is-active="modelValue === true">
          YES
          <template v-slot:icon>
            <img src="../../../img/wall-builder/icons/nfpa-yes.svg" />
          </template>
        </IconButton>
        <IconButton :on-click="() => $emit('update:modelValue', false)" :is-active="modelValue === false">
          NO
          <template v-slot:icon>
            <img src="../../../img/wall-builder/icons/nfpa-no.svg" />
          </template>
        </IconButton>
      </div>
    </div>
  </div>
</template>

<script>
import IconButton from "../components/IconButton.vue";
export default {
  data() {
    return {

    }
  },
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Boolean,
      default: null
    }
  },
  components: {
    IconButton
  }
}
</script>
